import '@/index.css';
import '@/styles/antd.min.css';
import '@ant-design/v5-patch-for-react-19';

import { initDatadogLogs } from '@/lib/datadog-logs';
import AntdProvider from '@/providers/AntdProvider';
import QueryProvider from '@/providers/query-provider';
import { router } from '@/routes';
import { TooltipProvider } from '@mgrvtechgroup/admin-ds';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';

/** Datadog Browser Logs 초기화 (production 빌드에서만 실제 전송) */
initDatadogLogs();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

createRoot(rootElement).render(
  <StrictMode>
    <AntdProvider>
      <QueryProvider>
        {/* admin-ds Tooltip은 TooltipProvider 없이는 호버해도 열리지 않는다(Base UI 계약) —
            mfms main.tsx와 동일하게 앱 전역에 한 번 감싼다(launchpad는 별도 라우트 트리라
            LaunchpadLayout에 로컬로 한 번 더 감쌈, 중첩 Provider는 무해). */}
        <TooltipProvider>
          <RouterProvider router={router} />
        </TooltipProvider>
      </QueryProvider>
    </AntdProvider>
  </StrictMode>,
);
